import { uniq } from 'lodash';
export function totalDiscountAmount(orderlines, discount) {
    if (discount === void 0) { discount = false; }
    var totalDiscount = 0;
    for (var i in orderlines) {
        var orderline = orderlines[i];
        if (orderline.linediscountamount) {
            totalDiscount = +totalDiscount + parseFloat(orderline.linediscountamount);
        }
        if (orderline.linediscountamount && discount === false) {
            discount = true;
        }
    }
    return totalDiscount;
}
export function humanReadableLineUnitPrices(masterId, colorCode, orderlines) {
    var prices = [];
    var line = orderlines.filter(function (item) {
        return item.masterId === masterId && item.colorCode === colorCode;
    });
    for (var i in line) {
        prices.push(line[i].unitPrice);
    }
    var sorted = prices.sort(function (a, b) { return +b - (+a); });
    var rounded = uniq(sorted.map(function (p) { return roundAmount(+p); }));
    return rounded.reverse().join(" / ");
}
export function totalLineDiscountAmount(masterId, colorCode, orderlines) {
    var totalDiscountAmount = 0;
    var line = orderlines.filter(function (item) {
        return item.masterId === masterId && item.colorCode === colorCode;
    });
    for (var i in line) {
        totalDiscountAmount = totalDiscountAmount + line[i].linediscountamount;
    }
    return totalDiscountAmount;
}
export function totalLineAmount(masterId, colorCode, orderlines) {
    var totalDiscountAmount = 0;
    var line = orderlines.filter(function (item) {
        return item.masterId === masterId && item.colorCode === colorCode;
    });
    for (var i in line) {
        totalDiscountAmount = totalDiscountAmount + line[i].amount;
    }
    return totalDiscountAmount;
}
export function getWHPWithDiscount(whp, discount) {
    discount = discount || 0;
    return whp - (whp * (discount / 100));
}
export function getSalesbookPrice(style, prices, currencyName) {
    if (currencyName === void 0) { currencyName = 'EUR'; }
    var key = style.masterId + style.colorCode;
    var activeSeasonPrices = prices;
    var output = "";
    if (key in activeSeasonPrices) {
        var element = activeSeasonPrices[key];
        if (element["HasDifferentialPrice"] > 0) {
            var WSP = "From " + addZeroes(element['WHP']) + "/", RRP = +addZeroes(element['MSRP']) + " " + currencyName;
            output = String(WSP + RRP);
        }
        else {
            var WHP = addZeroes(element['WHP']), MSRP = addZeroes(element['MSRP']);
            output = String(WHP + '/' + MSRP + " " + currencyName);
        }
    }
    return output;
}
function addZeroes(num) {
    if (num != null) {
        num = num.toString();
        var value = Number(num);
        var res = num.split(".");
        if (num.indexOf('.') === -1) {
            //value = value.toFixed(2);
            num = value.toString();
        }
        else if (res[1].length < 3) {
            // value = value.toFixed(2);
            num = value.toString();
        }
    }
    return num;
}
export var roundAmount = function (amount) {
    return amount.toLocaleString(navigator.language, { minimumFractionDigits: 2 });
};
//# sourceMappingURL=priceHelper.js.map